export const SET_FRAGMENTS = 'fragments/set-fragments';
export const SET_SELECTED = 'fragment/set-selected-fragment';
export const SET_PLUGINS = 'fragment/set-plugins';
export const SET_FILTERS = 'fragment/set-filters';
export const REMOVE_FRAGMENT = 'fragment/remove-fragment';
